<template>
  <div class="totals-shadow mb-2">
    <div class="totals-box p-2" @click.stop.prevent="$emit('openSidebar')">
      <div class="row w-100 mx-1">
        <div class="totals-info-wrapper col-3 p-0">
          <a href="#">
            <div @click.stop.prevent="goToJob" class="total-ref-id pointer">{{ total.ref_id }}</div>
          </a>
          <div class="total-info">
            {{ total.date }}
          </div>
        </div>
        <div class="totals-info-wrapper col-3 p-0">
          <div class="total-info-numbers">
            {{ total.carrier_total }}
          </div>
        </div>
        <div class="totals-info-wrapper col-3 p-0">
          <div class="total-info-numbers pl-2">
            {{ total.cluster_total }}
          </div>
        </div>
        <div class="totals-info-wrapper col-3 p-0">
          <div class="total-info-numbers justify-content-end pr-2">
            {{ total.balance }}
          </div>
          <span v-if="total.payment_status_id === 3" class="ml-2 total-status-paid text-center">
            paid
          </span>
        </div>
      </div>
    </div>
    <div v-if="expanded" class="totals-box p-2" @click.stop.prevent="$emit('openSidebar')">
      <div class="border-top-expanded row mx-1 w-100">
        <div class="col-12 row mt-2 pr-0">
          <div class="col-3">
            <label class="expanded-label">Time</label>
            <div class="expanded-col-data">
              {{ total.time }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Tips</label>
            <div class="expanded-col-data">
              {{ total.card_tips }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Fee</label>
            <div class="expanded-col-data">
              {{ total.mod_tier_id ? `${total.mod_tier_percentage}%` : `${total.percent}% (${total.fee })` }}
            </div>
          </div>
        </div>
        <div class="col-12 row mt-2 pr-0">
          <div class="col-3">
            <label class="expanded-label">Deposit</label>
            <div class="expanded-col-data">
              {{ total.deposit }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Cash</label>
            <div class="expanded-col-data">
              {{ total.cash_payment }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Credit</label>
            <div class="expanded-col-data">
              {{ total.total_credit }}
            </div>
          </div>
          <div class="col-3">
            <label class="expanded-label">Grand Total</label>
            <div class="expanded-col-data">
              {{ total.total_price }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TotalsBlockMobile',
  props: {
    total: {
      type: Object,
      default: () => ({}),
    },
    expanded: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    goToJob() {
      window.open(this.$router.resolve(`/jobs/edit/${this.total.job_id}`).href, '_blank');
    },
  },
};
</script>

<style scoped>
.totals-box {
  display: flex;
  justify-content: space-between;
  background: #ffffff;
  border-radius: 2px;
  min-height: 70px;
}

.totals-shadow {
  box-shadow: 0 2px 9px -4px rgba(15, 20, 54, 0.17), 0 7px 25px -3px rgba(50, 50, 93, 0.03);
}

.totals-box > div:first-child > div:first-child {
  padding: 12px 0 0 12px !important;
}
.totals-info-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
}
.total-ref-id {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
}
.total-ref-id:hover {
  color: #2962ff;
}
.total-info {
  font-size: 10px;
  color: #4c5669;
}
.total-info-numbers {
  font-size: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #4c5669;
}
.totals-icon {
  color: #c0c6cc;
}

.expanded-label {
  font-weight: bold;
  font-size: 12px;
  color: #4c5669;
  white-space: nowrap;
}

.expanded-col-data {
  font-size: 12px;
  color: #4c5669;
}

.border-top-expanded {
  border-top: 1px solid #bdbdbd;
}
</style>



// WEBPACK FOOTER //
// src/components/reports/TotalsBlockMobile.vue